// UserSentences.js
import useAuth from "./hooks/useAuth";
import UserSentencesSnapshot from "./UserSentencesSnapshot";
import UserSentencesDynamic from "./UserSentencesDynamic";
import UserSentencesIntensity from "./UserSentencesIntensity";

const UserSentences = ({ language, date, representation }) => {
    const { auth } = useAuth();

    return (
        <div className="w-full">
            {representation === 'Snapshot' ? (
                <UserSentencesSnapshot 
                    language={language} 
                    date={date} 
                />
            ) : representation === 'Dynamic' ? (
                <UserSentencesDynamic 
                    language={language} 
                    date={date} 
                />
            ) : (
                <UserSentencesIntensity 
                    language={language} 
                    date={date} 
                />
            )}
        </div>
    );
}

export default UserSentences;
